<template>
	<div :id="domID" class="pp_slide_wrap small-arrows" v-if="products.length > 0">
		<div class="arrow_r ease">
			<a href="javascript:void(0);" class="slider-arrow-r" ref="rightArrow">
				<arrow-right />
			</a>
		</div>
		<div class="arrow_l ease">
			<a href="javascript:void(0);" class="slider-arrow-l" ref="leftArrow">
				<arrow-left />
			</a>
		</div>
		<div class="pp_slide clearfix" v-if="products.length > 0">
			<slick ref="slick" :options="slickOptions">
				<Product
					v-bind:product="product"
					v-bind:index="index"
					v-bind:is_popup="true"
					v-bind:lazy_image="false"
					v-for="(product, index) in products"
					:key="product.id"
				></Product>
			</slick>
		</div>
	</div>
	<div v-else class="empty-slider">{{ wpData.globalOptions.upsell_page.general.empty_text }}</div>
</template>

<script>
	import Slick from "vue-slick";
	import arrowLeft from "../../assets/img/arrow_l.svg";
	import arrowRight from "../../assets/img/arrow_r.svg";
	import Product from "../Product/Product.vue";

	export default {
		name: "ProductSlider",
		props: ["products"],
		data() {
			return {
				wpData: wpData,
				domID: null,
			};
		},
		created() {
			this.domID = this.generateUniqueID();
		},
		computed: {
			slickOptions: function () {
				return {
					rtl: true,
					dots: false,
					infinite: true,
					arrows: true,
					centerMode: false,
					nextArrow: `#${this.domID} .slider-arrow-l`,
					prevArrow: `#${this.domID} .slider-arrow-r`,
					slidesToShow: 5,
					slidesToScroll: 5,
					autoplay: false,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 800,
							settings: "unslick",
						},
					],
				};
			},
		},
		methods: {
			generateUniqueID() {
				let result = "";
				const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
				const charactersLength = characters.length;
				for (let i = 0; i < 8; i++) {
					result += characters.charAt(Math.floor(Math.random() * charactersLength));
				}
				return result;
			},
		},
		components: {
			Slick,
			arrowLeft,
			arrowRight,
			Product,
		},
	};
</script>

<style lang="sass" scoped>
	.small-arrows .arrow_r a,
	.small-arrows .arrow_l a
		padding: 1rem 1rem
	   	margin-top: -3rem
		right: -3rem
	.small-arrows .arrow_l a
		right: auto
		left: -3rem
</style>
